import { values } from 'lodash';

import { DBDocSchema } from '../../../generic/db-doc/db-doc-schema';
import { SchemaField } from '../../../generic/serialization/schema-field';

import { UserPresenceConnectionDeviceType } from './user-presence-connection-device-type';

export class UserPresenceConnectionSchema extends DBDocSchema {
  public static readonly deviceType = 'deviceType';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Constants = class {
    public static readonly collection = 'connections';
  };

  static Defaults = class {
    public static readonly deviceType = undefined;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[UserPresenceConnectionSchema.deviceType] = SchemaField.string(
      UserPresenceConnectionSchema.Defaults.deviceType,
    )
      .valid(...values(UserPresenceConnectionDeviceType))
      .required();
    /* eslint-enable */

    return parameters;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Collection
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getCollection(orgId: string, userId: string): string {
    return `${this.orgDoc(orgId)}/userPresence/${userId}/${UserPresenceConnectionSchema.Constants.collection}`;
  }
}
